export function getCurrentDate(separator=''){

    let newDate = new Date()
    let year = newDate.getFullYear();
    
    //return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
    return `${year}`
    }